import Swiper from "swiper";
import SlidesCounter from "../../slides-counter/slides-counter";

const compareTable = document.querySelector(".js-comparison-table");

if (compareTable) {
    window.addEventListener("load", () => initTableSliders(compareTable));
}

function initTableSliders(compareTable) {
    const slidersArr = [];

    let slidesCounterElems = document.querySelectorAll(".js-comparison-items-slides-counter");
    const compareItems = document.querySelector(".js-comparison-items-slider");

    if (compareItems) {
        slidesCounterElems = Array.from(slidesCounterElems);
        const slidesCounterElemsActivated = [];

        for (const item of slidesCounterElems) {
            const slidesCounter = new SlidesCounter(item);
            slidesCounterElemsActivated.push(slidesCounter);
        }

        const compareItemsSlider = new Swiper(".js-comparison-items-slider", {
            slidesPerView: 2,
            spaceBetween: 8,
            allowTouchMove: true,
            resistanceRatio: 0.7,
            watchOverflow: true,

            pagination: {
                el: ".js-comparison-pagination",
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
            },

            navigation: {
                prevEl: ".js-comparison-button-prev",
                nextEl: ".js-comparison-button-next",
            },

            breakpoints: {
                768: {
                    resistanceRatio: 0,
                    slidesPerView: 3,
                    allowTouchMove: false,
                    spaceBetween: 28,
                },
            },

            on: {
                activeIndexChange() {
                    for (const slidesCounter of slidesCounterElemsActivated) {
                        slidesCounter.changeText(compareItemsSlider);
                    }
                },
            },
        });

        for (const slidesCounter of slidesCounterElemsActivated) {
            slidesCounter.setValueOfAllCounter(compareItemsSlider);
        }

        if (compareItemsSlider.slides.length < 3) {
            for (const slidesCounter of slidesCounterElemsActivated) {
                slidesCounter.hide();
            }
        }

        slidersArr.push(compareItemsSlider);
    }

    const comparisonDiagram = document.querySelector(".js-comparison-diagram-init");

    if (comparisonDiagram) {
        const comparisonDiagramSlider = new Swiper(".js-comparison-diagram-swiper-container", {
            slidesPerView: 2,
            allowTouchMove: true,
            spaceBetween: 8,
            resistanceRatio: 0.7,
            watchOverflow: true,

            controller: {
                control: slidersArr[0],
            },

            navigation: {
                prevEl: ".js-comparison-diagram-button-prev",
                nextEl: ".js-comparison-diagram-button-next",
            },

            breakpoints: {
                768: {
                    resistanceRatio: 0,
                    slidesPerView: 3,
                    spaceBetween: 28,
                },
            },
        });

        slidersArr.push(comparisonDiagramSlider);
    }

    const characteristicsBlocks = compareTable.querySelectorAll(".js-comparison-block-body");

    if (characteristicsBlocks) {
        for (const block of characteristicsBlocks) {
            const swiperContainer = block.querySelector(".swiper-container");

            const slider = new Swiper(swiperContainer, {
                slidesPerView: 2,
                allowTouchMove: true,
                spaceBetween: 8,
                resistanceRatio: 0.7,
                watchOverflow: true,

                observer: true,
                observeParents: true,
                preventClicks: false,

                controller: {
                    control: slidersArr[0],
                },

                breakpoints: {
                    768: {
                        resistanceRatio: 0,
                        slidesPerView: 3,
                        allowTouchMove: false,
                        spaceBetween: 28,
                    },
                },
            });

            slidersArr.push(slider);
        }
    }

    const fixedHeader = document.querySelector(".js-comparison-fixed-header");

    if (fixedHeader) {
        window.addEventListener("scroll", () => {
            fixedHeader.classList[window.pageYOffset > window.innerHeight * 0.65 ? "add" : "remove"]("active");
        });

        const fixedHeaderSlider = new Swiper(".js-comparison-fixed-header-slider", {
            slidesPerView: 2,
            allowTouchMove: true,
            spaceBetween: 8,
            resistanceRatio: 0.7,
            watchOverflow: true,

            controller: {
                control: slidersArr[0],
            },

            pagination: {
                el: ".js-comparison-fixed-header-pagination",
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
            },

            navigation: {
                prevEl: ".js-comparison-fixed-header-button-prev",
                nextEl: ".js-comparison-fixed-header-button-next",
            },

            breakpoints: {
                768: {
                    resistanceRatio: 0,
                    slidesPerView: 3,
                    allowTouchMove: false,
                    spaceBetween: 28,
                },
            },
        });

        slidersArr.push(fixedHeaderSlider);
    }

    slidersArr[0].controller.control = slidersArr.filter((item) => item !== slidersArr[0]);
}
